// extracted by mini-css-extract-plugin
module.exports = {"googleIcon":"OauthButton_googleIcon_PnF58"};